import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}
export function Breadcrumbs({
  items
}: BreadcrumbsProps) {
  return <nav aria-label="Breadcrumb" className="min-w-0" data-id="element-12" data-mp="2r78uiipbe9zw">
      <ol className="flex items-center gap-1.5 text-sm" data-id="element-13" data-mp="2m5ryp1lotdq6">
        {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return <li key={item.label} className="flex items-center gap-1.5 min-w-0" data-id="element-14" data-mp="1uevjvvg2gz09" data-mpi={i}>
              {i > 0 && <ChevronRightIcon className="w-3.5 h-3.5 text-gray-600 shrink-0" aria-hidden="true" data-id="element-15" data-mp="28eddqp87z2gh" />}
              {isLast ? <span aria-current="page" className="text-white font-medium truncate" data-id="element-16" data-mp="3jtjv3tcx8awp">
                  {item.label}
                </span> : item.onClick ? <button onClick={item.onClick} className="text-gray-400 hover:text-amber transition-colors truncate rounded focus:outline-none focus-visible:ring-1 focus-visible:ring-amber" data-id="element-17" data-mp="l8t1wfqhfgn7">
                  {item.label}
                </button> : <span className="text-gray-400 truncate" data-id="element-18" data-mp="106lg94kalyzt">{item.label}</span>}
            </li>;
      })}
      </ol>
    </nav>;
}